import React from "react";
import Field from "./Field";
import ColorPickerControl from "./ColorPickerControl";
import { FieldProps } from "./Types";

const ColorPickerField: React.FC<FieldProps> = ({ labelProps, controlProps, visible, disabled }) => {

    if (visible === false)
        return <></>;

    return (
        <Field {...labelProps}>
            <ColorPickerControl {...controlProps} disabled={disabled} />
        </Field>
    );
}
export default ColorPickerField;